import api from '@/api.js';

export default class {
  constructor(resource) {
    this.resource = resource;
  }

  create(payload) {
    return api.post(`${this.resource}`, payload);
  }

  get(page) {
    if (page) {
      return api.get(`${this.resource}/paginate?page=${page}&limit=10`);
    } else {
      return api.get(`${this.resource}`);
    }
  }

  getById(id) {
    return api.get(`${this.resource}/${id}`);
  }

  getWithSearch(search, customParams, page, limit) {
    let pageQs = page ? `&page=${page}` : '';
    let limitQs = limit ? `&limit=${limit}` : '';
    if (customParams) {
      return api.get(`${this.resource}/search?search=${search}&${customParams.name}=${customParams.id}${pageQs}${limitQs}`);
    } else {
      return api.get(`${this.resource}/search?search=${search}${pageQs}${limitQs}`);
    }
  }

  update(id, payload) {
    return api.put(`${this.resource}/${id}`, payload);
  }

  patch(id, payload) {
    return api.patch(`${this.resource}/${id}`, payload);
  }

  delete(id) {
    return api.delete(`${this.resource}/${id}`);
  }
}
